import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { ReferralFilterState } from './state';
import { scopeOfServiceMapping, PlacementType, serviceTypeMapping, ServiceType } from 'referral';
import { ServiceLocationEnumNameToValue } from 'placement/const';
import { ProviderAppActionPayload } from 'providerapp/core/reducer/action';

type Props = {
    filter: ReferralFilterState;
    dispatch: React.Dispatch<ProviderAppActionPayload>;
}

export function FilterBadges({filter, dispatch}:Props) {
    const values  = [
        ...(filter.serviceTypes.map((val) => serviceTypeMapping[val as ServiceType])),
        ...(filter.scopeOfServices.map((val) => scopeOfServiceMapping[val as PlacementType])),
        ...(filter.serviceLocationTypes.map((val) => ServiceLocationEnumNameToValue.get(val)).filter((val): val is string => val !== undefined)),
        ...filter.counties,
        ...filter.cities,
        ...filter.zipcodes
    ];

    const updateFilterByRemoveValue = (value: string) => {
        const newFilter = { ...filter };
        
        // Helper function to update filter and dispatch
        const updateAndDispatch = (filterKey: keyof ReferralFilterState, valueToRemove: string) => {
            const currentArray = filter[filterKey] as string[];
            newFilter[filterKey] = currentArray.filter(item => item !== valueToRemove) as any;
            dispatch({ type: 'REFERRAL_FILTER_ACTION', filter: newFilter });
        };

        // Check mapped values (service types, scope of services, service location types)
        const mappingChecks = [
            {
                mapping: serviceTypeMapping,
                filterKey: 'serviceTypes' as const
            },
            {
                mapping: scopeOfServiceMapping,
                filterKey: 'scopeOfServices' as const
            }
        ];

        for (const { mapping, filterKey } of mappingChecks) {
            const key = Object.keys(mapping).find(k => mapping[k as keyof typeof mapping] === value);
            if (key) {
                updateAndDispatch(filterKey, key);
                return;
            }
        }

        // Check service location types (Map-based)
        const serviceLocationTypeKey = Array.from(ServiceLocationEnumNameToValue.keys()).find(
            key => ServiceLocationEnumNameToValue.get(key) === value
        );
        if (serviceLocationTypeKey) {
            updateAndDispatch('serviceLocationTypes', serviceLocationTypeKey);
            return;
        }

        // Check direct string values (counties, cities, zipcodes)
        const directValueChecks: (keyof ReferralFilterState)[] = ['counties', 'cities', 'zipcodes'];
        
        for (const filterKey of directValueChecks) {
            const currentArray = filter[filterKey] as string[];
            if (currentArray.includes(value)) {
                updateAndDispatch(filterKey, value);
                return;
            }
        }
    };

    if (values.length === 0) {
        return <div></div>;
    }

    return (
    <div className='flex pl-5 items-start'>
        <div className='pt-1 pr-5 flex-grow-0'>
            Filter:
        </div>
        <div className='flex flex-grow flex-wrap'>
            {
                values.map((value) => (
                    <div key={value}
                         className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                        {value}
                        <button className='bg-transparent outline-none focus:outline-none'
                                onClick={() => updateFilterByRemoveValue(value)}>
                            <div
                                className='bg-transparent text-white opacity-75 ml-3 outline-none focus:outline-none flex items-center hover:opacity-100'>
                                <CancelIcon fontSize={"small"}/>
                            </div>
                        </button>
                    </div>
                ))
            }
        </div>
    </div>);
}
